export function SupportPage() {
  return (
    <div className="space-y-6 max-w-4xl">
      <div>
        <h1 className="text-2xl font-bold">Support</h1>
        <p className="text-sm text-ink-muted mt-1">Support channels and response commitments.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="card space-y-2 text-sm text-ink-muted">
          <div className="card-title">Contact</div>
          <div>Email: support@intellnet.cn</div>
          <div>Portal: https://aischub.intellnet.cn/support</div>
          <div>Hours: 9x5 standard, 24x7 for Severity 1 (Premium)</div>
        </div>
        <div className="card space-y-2 text-sm text-ink-muted">
          <div className="card-title">Initial Response Targets</div>
          <div>Severity 1: 1 hour</div>
          <div>Severity 2: 4 hours</div>
          <div>Severity 3: 1 business day</div>
          <div>Severity 4: 2 business days</div>
        </div>
      </div>
    </div>
  );
}
